import type { Incident, IncidentStatus } from '../types/incident.types'
import {
  STATUS_DOT_CLASS,
  STATUS_LABELS,
  STATUS_TEXT_CLASS,
} from '../constants/incidentMaps'
import { KanbanCard } from './KanbanCard'

interface KanbanColumnProps {
  status: IncidentStatus
  incidents: Incident[]
  onSelect?: (id: number) => void
}

export function KanbanColumn({ status, incidents, onSelect }: KanbanColumnProps): JSX.Element {
  return (
    <section className="flex w-60 shrink-0 flex-col">
      <header className="mb-3 flex items-center justify-between px-1">
        <div className="inline-flex items-center gap-2">
          <span className={`h-2 w-2 rounded-full ${STATUS_DOT_CLASS[status]}`} />
          <span className={`text-sm font-semibold ${STATUS_TEXT_CLASS[status]}`}>
            {STATUS_LABELS[status]}
          </span>
        </div>
        <span className="text-xs text-gray-400">{incidents.length}</span>
      </header>
      <div className="flex flex-col gap-3">
        {incidents.map((incident) => (
          <KanbanCard key={incident.id} incident={incident} onSelect={onSelect} />
        ))}
      </div>
    </section>
  )
}
